import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { BasketView } from 'ish-core/models/basket/basket.model';

@Component({
  selector: 'ish-promotion-remove',
  templateUrl: './promotion-remove.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, TranslateModule],
})
export class PromotionRemoveComponent implements OnInit {
  private checkoutFacade = inject(CheckoutFacade);

  basket$: Observable<BasketView>;

  readonly code = input.required<string>();

  ngOnInit() {
    this.basket$ = this.checkoutFacade.basket$;
  }

  removePromotion() {
    this.checkoutFacade.removePromotionCodeFromBasket(this.code());
  }
}
